export interface Category {
  id: string;
  name: string;
  url: string;
  icon: string;
  image: string;
}

export const categories: Category[] = [
  {
    id: 'shoes',
    name: 'Tênis',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    icon: 'ri-footprint-line',
    image: 'https://readdy.ai/api/search-image?query=Pair%20of%20fashionable%20white%20and%20grey%20athletic%20sneakers%20on%20warm%20terracotta%20surface%2C%20side%20by%20side%2C%20soft%20natural%20lighting%2C%20clean%20product%20photography%2C%20textile%20mesh%20and%20leather%20details%2C%20sporty%20lifestyle%20aesthetic%2C%20minimal%20composition%20with%20warm%20earthy%20background%20tones&width=400&height=400&seq=cat-shoes-v2&orientation=squarish',
  },
  {
    id: 'hoodies',
    name: 'Moletons / Suéteres',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    icon: 'ri-t-shirt-line',
    image: 'https://readdy.ai/api/search-image?query=Oversized%20heather%20grey%20cotton%20hoodie%20folded%20neatly%20on%20warm%20beige%20surface%2C%20soft%20diffused%20overhead%20lighting%2C%20casual%20streetwear%20photography%2C%20visible%20drawstring%20and%20kangaroo%20pocket%20details%2C%20cozy%20textural%20fabric%2C%20minimalist%20product%20presentation%20with%20neutral%20composition&width=400&height=400&seq=cat-hoodies-v2&orientation=squarish',
  },
  {
    id: 'tshirts',
    name: 'Camisetas',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    icon: 'ri-shirt-line',
    image: 'https://readdy.ai/api/search-image?query=Stack%20of%20folded%20white%20and%20black%20cotton%20t-shirts%20on%20warm%20cream%20surface%2C%20top%20down%20flat%20lay%20photography%2C%20soft%20natural%20light%2C%20clean%20minimal%20composition%2C%20visible%20fabric%20texture%2C%20casual%20fashion%20essentials%20aesthetic%2C%20editorial%20product%20styling&width=400&height=400&seq=cat-tshirts-v2&orientation=squarish',
  },
  {
    id: 'jackets',
    name: 'Jaquetas',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    icon: 'ri-t-shirt-2-line',
    image: 'https://readdy.ai/api/search-image?query=Olive%20green%20nylon%20bomber%20jacket%20laid%20flat%20on%20warm%20sand%20surface%2C%20soft%20side%20lighting%2C%20outdoor%20utility%20fashion%20aesthetic%2C%20visible%20zipper%20and%20pocket%20details%2C%20matte%20fabric%20texture%2C%20clean%20product%20photography%2C%20earthy%20military%20inspired%20tones&width=400&height=400&seq=cat-jackets-v2&orientation=squarish',
  },
  {
    id: 'pants',
    name: 'Calças / Shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    icon: 'ri-pantone-line',
    image: 'https://readdy.ai/api/search-image?query=Pair%20of%20light%20wash%20distressed%20denim%20jeans%20folded%20on%20warm%20cream%20surface%2C%20soft%20natural%20lighting%2C%20casual%20streetwear%20photography%2C%20visible%20whiskering%20and%20fading%20details%2C%20cotton%20denim%20texture%2C%20relaxed%20fashion%20aesthetic%2C%20minimal%20product%20presentation&width=400&height=400&seq=cat-pants-v2&orientation=squarish',
  },
  {
    id: 'headwear',
    name: 'Chapéus / Bonés',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    icon: 'ri-contrast-drop-line',
    image: 'https://readdy.ai/api/search-image?query=Black%20baseball%20cap%20with%20curved%20brim%20on%20warm%20beige%20surface%2C%20top%20down%20view%2C%20soft%20studio%20lighting%2C%20clean%20product%20photography%2C%20visible%20embroidered%20logo%20detail%2C%20cotton%20twill%20fabric%20texture%2C%20streetwear%20accessory%20aesthetic%2C%20minimal%20composition&width=400&height=400&seq=cat-headwear-v2&orientation=squarish',
  },
  {
    id: 'sets',
    name: 'Conjuntos',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    icon: 'ri-stack-line',
    image: 'https://readdy.ai/api/search-image?query=Matching%20grey%20sweatpants%20and%20hoodie%20set%20arranged%20together%20on%20warm%20cream%20surface%2C%20flat%20lay%20photography%2C%20soft%20natural%20lighting%2C%20coordinated%20loungewear%20aesthetic%2C%20visible%20ribbed%20cuffs%20and%20drawstring%20details%2C%20comfortable%20casual%20fashion%2C%20clean%20composition&width=400&height=400&seq=cat-sets-v2&orientation=squarish',
  },
  {
    id: 'underwear',
    name: 'Roupa Íntima',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    icon: 'ri-checkbox-blank-circle-line',
    image: 'https://readdy.ai/api/search-image?query=Neatly%20folded%20white%20cotton%20boxer%20briefs%20on%20warm%20beige%20linen%20surface%2C%20soft%20diffused%20lighting%2C%20clean%20minimal%20product%20photography%2C%20visible%20elastic%20waistband%20detail%2C%20soft%20fabric%20texture%2C%20understated%20essential%20fashion%2C%20elegant%20simple%20composition&width=400&height=400&seq=cat-underwear-v2&orientation=squarish',
  },
  {
    id: 'jersey',
    name: 'Camisas de Time',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    icon: 'ri-football-line',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20soccer%20football%20jersey%20with%20vibrant%20stripes%20laid%20flat%20on%20warm%20neutral%20surface%2C%20soft%20studio%20lighting%2C%20sports%20fashion%20photography%2C%20visible%20team%20crest%20and%20sponsor%20logo%20details%2C%20breathable%20polyester%20mesh%20fabric%2C%20athletic%20aesthetic%2C%20clean%20product%20presentation&width=400&height=400&seq=cat-jersey-v2&orientation=squarish',
  },
  {
    id: 'accessories',
    name: 'Acessórios',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    icon: 'ri-glasses-line',
    image: 'https://readdy.ai/api/search-image?query=Collection%20of%20fashion%20accessories%20including%20sunglasses%20watch%20and%20bracelet%20arranged%20on%20warm%20cream%20surface%2C%20flat%20lay%20photography%2C%20soft%20natural%20lighting%2C%20lifestyle%20product%20styling%2C%20mixed%20metal%20and%20acetate%20materials%2C%20editorial%20accessory%20composition%2C%20elevated%20casual%20aesthetic&width=400&height=400&seq=cat-accessories-v2&orientation=squarish',
  },
  {
    id: 'bags',
    name: 'Bolsas / Mochilas',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    icon: 'ri-briefcase-line',
    image: 'https://readdy.ai/api/search-image?query=Black%20nylon%20backpack%20with%20front%20pockets%20on%20warm%20sand%20colored%20surface%2C%20side%20angle%20view%2C%20soft%20studio%20lighting%2C%20clean%20product%20photography%2C%20visible%20zipper%20and%20buckle%20details%2C%20durable%20fabric%20texture%2C%20urban%20utility%20aesthetic%2C%20minimal%20composition&width=400&height=400&seq=cat-bags-v2&orientation=squarish',
  },
  {
    id: 'belts',
    name: 'Cintos',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    icon: 'ri-links-line',
    image: 'https://readdy.ai/api/search-image?query=Brown%20leather%20belt%20coiled%20elegantly%20on%20warm%20cream%20surface%2C%20top%20down%20view%2C%20soft%20natural%20lighting%2C%20luxury%20accessory%20photography%2C%20visible%20stitching%20and%20brass%20buckle%20details%2C%20genuine%20leather%20texture%2C%20refined%20minimalist%20aesthetic%2C%20clean%20sophisticated%20composition&width=400&height=400&seq=cat-belts-v2&orientation=squarish',
  },
  {
    id: 'perfumes',
    name: 'Perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    icon: 'ri-drop-line',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20glass%20perfume%20bottle%20with%20amber%20liquid%20on%20warm%20beige%20surface%2C%20soft%20directional%20lighting%20creating%20subtle%20shadow%2C%20luxury%20fragrance%20photography%2C%20visible%20atomizer%20and%20cap%20details%2C%20crystal%20glass%20texture%2C%20sophisticated%20beauty%20aesthetic%2C%20clean%20minimal%20composition&width=400&height=400&seq=cat-perfumes-v2&orientation=squarish',
  },
  {
    id: 'other',
    name: 'Outros Itens',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    icon: 'ri-more-line',
    image: 'https://readdy.ai/api/search-image?query=Assorted%20lifestyle%20products%20including%20electronics%20case%20wallet%20and%20keychain%20on%20warm%20cream%20surface%2C%20flat%20lay%20photography%2C%20soft%20natural%20lighting%2C%20everyday%20carry%20aesthetic%2C%20mixed%20materials%20and%20textures%2C%20casual%20lifestyle%20product%20styling%2C%20clean%20organized%20composition&width=400&height=400&seq=cat-other-v2&orientation=squarish',
  },
];